import { useParams } from "react-router-dom";
import { useBrigades } from "./use-brigades";

export const useSelectedBrigade = () => {
  const brigadeIdParam = useParams().id;
  const selectedBrigadeId = brigadeIdParam
    ? parseInt(brigadeIdParam, 10)
    : null;

  const { data: brigades } = useBrigades();

  return brigades?.find((brigade) => brigade.id === selectedBrigadeId);
};
